import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import stories from './stories.js'
import { hasAlarmExpired, createAlarmTimeSecondsFromNow } from '../../alarm/index.js'

const initialState = {
  // 0 will be scene 1
  sceneIndex: 0,
  showScene: true
}

export const openingScene = createSlice({
  name: 'openingScene',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(skipToNextScene.pending, (state) => {
      state.showScene = false
    })
    builder.addCase(skipToNextScene.fulfilled, (state) => {
      state.showScene = true
      state.sceneIndex += 1
    })
  }
})

export const { timerTick } = openingScene.actions

export const skipToNextScene = createAsyncThunk('openingScene/skipToNextScene', async (_, thunkApi) => {
  const delay = new Promise((resolve) => {
    setTimeout(resolve, 500)
  })

  await delay
})

export const selectScene = ({ openingScene: state }) => {
  const stepNum = state.sceneIndex
  const story = stories[stepNum]
  return state.showScene && story && story.scene
}

export const selectSceneArt = ({ openingScene: state }) => {
  const stepNum = state.sceneIndex
  const story = stories[stepNum]
  return state.showScene && story && story.sceneArt
}

export const selectIsShowScene = ({ openingScene: state }) => {
  return state.showScene
}

export const selectIsOpeningSceneComplete = ({ openingScene: state }) => {
  return state.sceneIndex >= stories.length
}

export default openingScene.reducer
